import { render } from "./DashboardProgressBar.vue?vue&type=template&id=12d8addf"
import script from "./DashboardProgressBar.vue?vue&type=script&lang=ts"
export * from "./DashboardProgressBar.vue?vue&type=script&lang=ts"
script.render = render

export default script